export default {"src":"/_next/static/media/cart.4bef65c2.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};